import { render, staticRenderFns } from "./v-mod-ft-btn.vue?vue&type=template&id=20cfe4b7"
import script from "./v-mod-ft-btn.vue?vue&type=script&lang=js"
export * from "./v-mod-ft-btn.vue?vue&type=script&lang=js"
import style0 from "./v-mod-ft-btn.vue?vue&type=style&index=0&id=20cfe4b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports